<template>
  <div>
    <!-- toasts message -->
    <v-card color="grey lighten-4">
      <v-snackbar :timeout="timeout" :color="color" :left="left" v-model="snackbar">{{ message }}</v-snackbar>
    </v-card>
    <!-- /toasts message -->

    <!-- Confirmation delete box -->
    <v-layout row justify-center>
      <v-dialog v-model="confirmModel" max-width="290">
        <v-card>
          <v-card-text>Are you sure you want to delete this data?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click.native="confirmModel = false">Disagree</v-btn>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="confirmDelete(row_index, delete_id)"
            >Agree</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation delete box -->

 
    <statusForm :formSchema="formSchema" v-on:emitCloseModal="close"></statusForm>

    <v-card-title>
      <h2> Procurement Status </h2>
      <v-spacer></v-spacer>
      <v-text-field append-icon="search" label="Search" single-line hide-details v-model="search"></v-text-field>
    </v-card-title>

    <v-data-table
      v-bind:headers="headers"
      v-bind:items="items"
      v-bind:search="search"
      v-bind:pagination.sync="pagination"
      :total-items="totalItems"
      :loading="loading"
      class="elevation-1"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{ ++(props.index) }}</td>
        <td class="text-xs-left">{{ props.item.name }}</td>

        <td class="justify-center layout px-0">
          <v-btn icon class="mx-0" v-if="userRole.updateButton" @click="editItem(props.index, props.item)">
            <v-icon color="teal">edit</v-icon>
          </v-btn>
          <v-btn icon class="mx-0" v-if="userRole.deleteButton" @click="deleteItem(props.index, props.item.id)">
            <v-icon color="pink">delete</v-icon>
          </v-btn>
        </td>
      </template>

      <template slot="no-data">
        <v-btn color="primary" @click="getDataFromApi()">Reset</v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
let commonService = require("../../../services/common.service");

import statusForm from "./statusForm.vue";
export default {
  components: {
    statusForm
  },

  data: () => ({
    dialog: false,
    totalItems: 0,
    loading: true,
    pagination: {
      sortBy: "id",
      descending: true
    },
    search: "",

    headers: [
      {
        text: "SL",
        align: "left",
        sortable: false,
        value: "id"
      },
      {
        text: "Status Name",
        align: "left",
        value: "name"
      },
      {
        text: "Action",
        align: "left",
        value: ""
      }
    ],

    items: [],

    delete_id: "",
    row_index: "",
    confirmModel: false,
    snackbar: false,
    color: "success",
    mode: "",
    timeout: 3000,
    left: "left",
    message: "",

    leaveTypeModal: false,
    formSchema: {
      id: "",
      name: ""
    },

    queryData: {
      sortBy: "id",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      search_val: ""
    }
  }),

  computed: {
    userRole() {
      return this.$store.getters.get_USER_ROLE_DATA;
    }
  },

  mounted() {
    this.loadData();
    this.message = "Data loading!";
    this.snackbar = true;
  },

  methods: {
    loadData(pagination) {
      commonService.getAllData("proc_status").then(res => {
        this.items = res.data;
        this.loading = false;
      });
    },

    editItem(id, data) {
      this.formSchema = data;
      this.leaveTypeModal = true;
    },

    deleteItem(index, id) {
      this.row_index = index;
      this.delete_id = id;
      this.confirmModel = true;
    },

    confirmDelete(row_index, id) {
      commonService.deleteRow(id, "proc_status").then(res => {
        this.items.splice(row_index, 1);
        this.close(res.message);
        this.confirmModel = false;
      });
    },

    close(data) {
      this.leaveTypeModal = false;
      if (data.status == 1) {
        this.data = data;
        this.message = data.message
        this.snackbar = true;
        this.loadData();
      };
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/procurement/status/status_list.vue